import { InlineEditComponent } from '@/vindication/components/inline-edit/inline-edit.component';
import { VindicationApiService } from '@/vindication/vindication.api.service';
import { TableContractor } from '@/vindication/vindication.model';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-contractor-info',
	standalone: true,
	imports: [MatCardModule, InlineEditComponent],
	templateUrl: './contractor-info.component.html',
	styleUrl: './contractor-info.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractorInfoComponent {
	readonly contractor = input.required<TableContractor>();
	readonly phoneLoader = output<boolean>();
	readonly mailsLoader = output<boolean>();
	readonly updatedPhone = output<string>();
	readonly updatedMails = output<string[]>();

	private readonly vindicationApiService = inject(VindicationApiService);
	private readonly cdr = inject(ChangeDetectorRef);

	savePhone(newValue: string | string[]): void {
		if (Array.isArray(newValue)) {
			return;
		}
		this.phoneLoader.emit(true);
		this.vindicationApiService
			.patchContractor(this.contractor()?.id, { phone: newValue })
			.pipe(
				finalize(() => {
					this.phoneLoader.emit(false);
					this.cdr.detectChanges();
				}),
			)
			.subscribe((updated) => {
				this.updatedPhone.emit(updated.phone);
			});
	}

	saveMails(newMails: string | string[]): void {
		if (!Array.isArray(newMails)) {
			return;
		}
		this.mailsLoader.emit(true);
		this.vindicationApiService
			.patchContractor(this.contractor()?.id, { mails: newMails })
			.pipe(
				finalize(() => {
					this.mailsLoader.emit(false);
					this.cdr.detectChanges();
				}),
			)
			.subscribe((updated) => {
				this.updatedMails.emit(updated.mails);
			});
	}
}
